/*eslint-disable*/
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active-link',
  linkExactActiveClass: 'active-link',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/accommodation'
    },
    {
      path: '/teacher',
      name: 'home',
      component: () => import('../views/Layout/Admin'),
      redirect: 'teacher',
      children: [
        {
          path: '/home',
          name: 'homePage',
          // component: () => import('../views/Users')
          component: () => import('../views/Layout/Dashboard/DashBoard.vue')
        },
        // {
        //   name: '/',
        //   path: '/',
        //   component: () => import('../views/Layout/Dashboard/DashBoard.vue')
        // },
        // {
        //   name: 'teacher',
        //   path: '/teacher',
        //   component: () => import('../views/Teachers/TeacherView.vue')
        // },
        {
          name: 'category',
          path: '/category',
          component: () => import('../views/Category/CategoriesView.vue')
        },
        {
          name: 'Accomodation',
          path: '/accommodation',
          component: () => import('../views/Accomodation/AccomodationView.vue')
        },
        {
          name: 'Behaviour',
          path: '/behaviour',
          component: () => import('../views/Behaviour/BehaviourView.vue')
        },
        {
          name: 'membership',
          path: '/membership',
          component: () => import('../views/MemberShip/MembershipView.vue')
        },
        {
          name: 'SubCategory',
          path: '/subcategory',
          component: () => import('../views/Category/SubCategoryView.vue')
        }
      ]
    },
    {
      path: '/privacypolicy',
      name: 'privacypolicy',
      component: () => import('../views/PrivacyPolicy/privacypolicy.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../views/PrivacyPolicy/contactUs.vue')
    },
    {
      path: '/',
      name: 'login',
      component: () => import('../views/Layout/Account'),
      redirect: 'login',
      children: [
        {
          path: '/login',
          name: 'loginPage',
          component: () => import('../views/Layout/Account/login.vue')
        },
        {
          path: '/login/signup',
          name: 'signup',
          component: () => import('../views/Layout/Account/SignUp.vue')
        }
      ]
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  if (store.getters['IsAdminLogin'] == null) {
    if (to.name != 'loginPage' || to.name != 'privacypolicy' || to.name != 'contact') {
      next();
    } else {
      next({ name: 'loginPage' });
    }
  } else {
    if (to.name == 'loginPage') {
      next({ name: 'teacher' });
    } else {
      next();
    }
  }
});
export default router;
